export default __webpack_public_path__ + "static/media/buzzer-pressed-yellow.7a8cd35c.png";